"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BodyPortal", {
    enumerable: true,
    get: function() {
        return BodyPortal;
    }
});
const _react = require("react");
const _reactdom = require("react-dom");
const BodyPortal = (param)=>{
    let { children } = param;
    const [modalContainer, setModalContainer] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        // access `document` safely in here since useEffect runs on client side only
        const modalElement = document.createElement("div");
        document.body.appendChild(modalElement);
        setModalContainer(modalElement);
    }, []);
    return modalContainer == null ? null : /*#__PURE__*/ (0, _reactdom.createPortal)(children, modalContainer);
};

//# sourceMappingURL=BodyPortal.js.map